import React from "react";
import { formatKennitala, getUserTypeTranslations } from "../../utils";
import { SvgTrashIcon, SvgPenIcon, SvgCheckIcon } from '../svg'
import { revokeEmployerAccess } from "../../api/employer-access/actions";
// import { updateCompanyDetails } from '../../api/company-details/actions'

class EmployeeOverview extends React.Component {
    constructor(props) {
        super(props)


        this.deleteUser = this.deleteUser.bind(this)
    }

    deleteUser(company, user){
        this.props.dispatch(revokeEmployerAccess({company_id: company, user_id: user}))
    }

    render() {
        let employees = this.props.companyDetails.data.UserList

        // if(this.props.companyDetails.isFetching === false && JSON.stringify(this.props.companyDetails.data) !== "{}"){
        if(employees !== undefined){

            return (
                <>
                <table className="employee-table">
                    <thead>
                        <tr className="et-rows row">
                            <th className="table-cell">Nafn</th>
                            <th className="table-cell">Kennitala</th>
                            <th className="table-cell user-type">Réttindi</th>
                            <td className="table-cell edit-button"></td>
                        </tr>
                    </thead>
                    <tbody>
                        { employees.map((item) => 
                            <tr key={item} className="et-rows row">
                                <td className="table-cell">{item.first_name} {item.last_name}</td>
                                <td className="table-cell">{formatKennitala(item.kennitala)}</td>
                                <td className="table-cell user-type">{getUserTypeTranslations(item.accessType)}</td>
                                <td className="table-cell edit-button">
                                    { this.props.companyDetails.currentUser && !item.currentUser && this.props.companyDetails.currentUser.accessType === "superuser" &&
                                        <a onClick={(e) => window.confirm("Ertu viss um að þú viljir eyða þessum aðgangi?") && this.deleteUser(this.props.company.company_id, item.kennitala)}><SvgTrashIcon/></a>
                                    }
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>


                </>
            )
        }
        else return <></>
    }
}

export default EmployeeOverview